// reducer.js
interface IndicatorPackage {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: null | number;
  updated_by_id: null | number;
  name: string;
  code: null | string;
  type: string;
}

interface Permission {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: string |  null;
  updated_by_id: string | null;
  is_deleted: boolean;
  deleted_at: string | null;
  name: string;
  code: string;
  group: string;
} 

interface Menu {
  id: number;
  created_at:string;
  updated_at: string;
  created_by_id: string | null;
  updated_by_id: string | null;
  is_deleted: boolean;
  deleted_at: string | null;
  name: string;
  code: string;
  url: string;
}    

export type levelType =
"Facility" | "Region" | "MoH" | "Super Admin";

export type RoleType =
  | "FACUR"
  | "ZONE"
  | "WOREDA"
  | "HEABRU"
  | "FACST"
  | "QTH"
  | "QTM"
  | "FACAD"
  | "MOHDQMTATM"
  | "MOHQITM"
  | "MOHAD";

export interface Role {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: null;
  updated_by_id: null;
  name: string;
  level: levelType;
  code: RoleType;
  is_super_admin: string;
  permissions: Permission[];
  menus: Menu[];
}

export interface RoleState {
  data: Role[];
  error: string | null;
}

export interface Action {
  type: string;
  payload: any;
}

const roleInitialState: RoleState = {
  data: [],
  error: null,
};

export const roleReducer = (
  state: RoleState = roleInitialState,
  action: Action
): RoleState => {
  switch (action.type) {
    case "FETCH_ROLES_SUCCESS":
      return { ...state, data: action.payload };
    case "FETCH_ROLES_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
